function bytesToBase64(bytes: Uint8Array) {
  const binString = Array.from(bytes, (byte) =>
    String.fromCodePoint(byte),
  ).join('');
  return window.btoa(binString);
}

/**
 * This function encodes state as base64 string.
 *
 * @example
 * ```js
 * // as "eyJmb28iOiLwn5+iIn0="
 * const encodedState = getEncodedState({ foo: 'bar' });
 * ```
 */
export function getEncodedState<StateType>(state: StateType) {
  return bytesToBase64(new TextEncoder().encode(JSON.stringify(state)));
}
